import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import MiniDrawer from "@meetyoo/components/src/components/Drawer/MiniDrawer";

import DrawerHomeContent from "../DrawerHomeContent";
import DrawerPMContent from "../DrawerPMContent";
import DrawerBillingContent from "../DrawerBillingContent";
import DrawerProjectMailContent from "../DrawerProjectMailContent";

import { PCMBACKEND, NAVISION, ZAMMAD } from "../../../constants/rights";
import { setShowSideDrawer, setAppbarTitle } from "../../../actions/ui";

const drawerContent = (user, rights, setAppbarTitleFn) => {
  const content = [<DrawerHomeContent key="drawer-home" onClickFn={() => setAppbarTitleFn("home")} />];
  if (rights.includes(PCMBACKEND))
    content.push(<DrawerPMContent key="drawer-pm" onClickFn={() => setAppbarTitleFn("passcodeManager")} />);
  if (rights.includes(NAVISION))
    content.push(
      <DrawerBillingContent key="drawer-billing" user={user} onClickFn={() => setAppbarTitleFn("billing")} />
    );
  if (rights.includes(ZAMMAD)) content.push(<DrawerProjectMailContent key="drawer-projectmail" />);
  return content;
};

export const DrawerComponent = ({
  sideDrawerOpen,
  user,
  rights,
  sideDrawerOpenHandler,
  setAppbarTitleFn,
  sideDrawerWidth,
}) => {
  return (
    <MiniDrawer
      drawerWidth={sideDrawerWidth}
      sideDrawerOpen={sideDrawerOpen}
      sideDrawerOpenHandler={() => sideDrawerOpenHandler(sideDrawerOpen)}
    >
      {drawerContent(user, rights, setAppbarTitleFn)}
    </MiniDrawer>
  );
};

DrawerComponent.propTypes = {
  sideDrawerOpen: PropTypes.bool.isRequired,
  user: PropTypes.string.isRequired,
  rights: PropTypes.array.isRequired,
  sideDrawerOpenHandler: PropTypes.func.isRequired,
  setAppbarTitleFn: PropTypes.func.isRequired,
  sideDrawerWidth: PropTypes.number.isRequired,
};

const mapStateToProps = state => {
  return {
    sideDrawerOpen: state.ui.sideDrawerOpen,
    user: state.oauth.username,
    rights: state.oauth.rights,
    sideDrawerWidth: state.ui.sideDrawerWidth,
    token: state.oauth.authData,
  };
};

const mapDispatchToProps = dispatch => ({
  sideDrawerOpenHandler: sideDrawerOpen => dispatch(setShowSideDrawer(!sideDrawerOpen)),
  setAppbarTitleFn: title => dispatch(setAppbarTitle(title)),
});

const Drawer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawerComponent);

export default Drawer;
